import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  FaCheckCircle,
  FaBoxOpen,
  FaTruck,
  FaHome,
  FaShoppingBag,
  FaArrowLeft,
  FaCopy,
  FaExternalLinkAlt,
  FaTimesCircle,
} from 'react-icons/fa';
import { MdPayment, MdReceipt, MdLocalShipping } from 'react-icons/md';
import { BiPackage } from 'react-icons/bi';
import Spinner from '../components/Spinner';
import html2pdf from 'html2pdf.js';

const OrderDetails = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const backendUrl = import.meta.env.VITE_BACKEND_URL;
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const trackingIdRef = useRef(null);
  const invoiceRef = useRef(null);
  const [showInvoice, setShowInvoice] = useState(false);

  const InvoiceComponent = () => {
    if (!order) return null;

    return (
      <div
        ref={invoiceRef}
        id="invoice-content"
        style={{
          display: 'block',
          fontFamily: "'Poppins', sans-serif",
          color: '#333',
          background: '#fff',
          padding: '15px',
          maxWidth: '100%',
          width: '100%',
          margin: '0',
          fontSize: '11px',
          lineHeight: '1.3',
          boxSizing: 'border-box',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '2px solid #65000B',
          }}
        >
          <div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <img
                src="https://res.cloudinary.com/dubbklkla/image/upload/v1750342713/Group_3_xb9pxx.png"
                alt="Zarviya"
                crossOrigin="anonymous"
                style={{
                  height: '70px',
                  width: '70px',
                  marginBottom: '8px',
                  objectFit: 'contain',
                  maxWidth: '100%',
                  display: 'block',
                }}
              />

              <div
                style={{
                  fontFamily: 'Cinzel Decorative, serif',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#65000B',
                  letterSpacing: '1px',
                }}
              >
                Zarviya
              </div>
            </div>

            <div style={{ fontSize: '10px', color: '#666' }}>
              <div>contact@zarviya.com</div>
              <div>zarviya.com</div>
            </div>
          </div>

          <div style={{ textAlign: 'right' }}>
            <h1
              style={{
                margin: '0 0 6px 0',
                color: '#2a081a',
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              INVOICE
            </h1>
            <div style={{ fontSize: '10px' }}>
              <div style={{ marginBottom: '4px' }}>
                <strong>Invoice: #</strong> {order.invoiceId || order.orderId}
              </div>
              <div style={{ marginBottom: '4px' }}>
                <strong>Date:</strong>{' '}
                {new Date(order.date).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </div>

              <div>
                <strong>Status:</strong>
                <span
                  style={{
                    color: '#6b7280', // gray-500
                    fontWeight: 'bold',
                    marginLeft: '4px',
                  }}
                >
                  {order.payment ? 'PAID' : 'PENDING'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Billing Information */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '15px',
            gap: '20px',
          }}
        >
          <div style={{ flex: 1 }}>
            <h3
              style={{
                margin: '0 0 6px 0',
                color: '#2a081a',
                fontSize: '12px',
                fontWeight: 'bold',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              BILL TO:
            </h3>
            <div style={{ fontSize: '10px', lineHeight: '1.2' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>
                {order.address.firstName} {order.address.lastName}
              </div>
              <div>{order.address.street}</div>
              <div>
                {order.address.city}, {order.address.state} {order.address.zipcode}
              </div>
              <div>{order.address.country}</div>
              <div style={{ marginTop: '4px' }}>
                <div>Email: {order.address.email}</div>
                <div>Phone: {order.address.phone}</div>
              </div>
            </div>
          </div>

          <div style={{ flex: 1, textAlign: 'right' }}>
            <h3
              style={{
                margin: '0 0 6px 0',
                color: '#2a081a',
                fontSize: '12px',
                fontWeight: 'bold',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              FROM:
            </h3>
            <div style={{ fontSize: '10px', lineHeight: '1.2' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>zarviya</div>
              <div>contact@zarviya.com</div>
              <div>zarviya.com</div>
            </div>
          </div>
        </div>

        {/* Order Summary */}
        <div style={{ marginBottom: '15px' }}>
          <h3
            style={{
              color: '#2a081a',
              margin: '0 0 8px 0',
              fontSize: '12px',
              fontWeight: 'bold',
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            ORDER SUMMARY
          </h3>

          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ddd',
            }}
          >
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th
                  style={{
                    padding: '6px 8px',
                    border: '1px solid #ddd',
                    textAlign: 'left',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  PRODUCT
                </th>
                <th
                  style={{
                    padding: '6px 8px',
                    border: '1px solid #ddd',
                    textAlign: 'center',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                    width: '50px',
                  }}
                >
                  QTY
                </th>
                <th
                  style={{
                    padding: '6px 8px',
                    border: '1px solid #ddd',
                    textAlign: 'right',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                    width: '70px',
                  }}
                >
                  PRICE
                </th>
                <th
                  style={{
                    padding: '6px 8px',
                    border: '1px solid #ddd',
                    textAlign: 'right',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                    width: '70px',
                  }}
                >
                  TOTAL
                </th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, idx) => (
                <tr key={idx}>
                  <td
                    style={{
                      padding: '6px 8px',
                      border: '1px solid #ddd',
                      fontSize: '10px',
                    }}
                  >
                    {item.name}{' '}
                    {item.size &&
                      item.size !== 'default' &&
                      item.size !== 'null' &&
                      `(${item.size})`}
                  </td>

                  <td
                    style={{
                      padding: '6px 8px',
                      border: '1px solid #ddd',
                      textAlign: 'center',
                      fontSize: '10px',
                    }}
                  >
                    {item.quantity}
                  </td>
                  <td
                    style={{
                      padding: '6px 8px',
                      border: '1px solid #ddd',
                      textAlign: 'right',
                      fontSize: '10px',
                    }}
                  >
                    ₹{item.price.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: '6px 8px',
                      border: '1px solid #ddd',
                      textAlign: 'right',
                      fontSize: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    ₹{(item.price * item.quantity).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Payment Details and Totals */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '15px',
            gap: '20px',
          }}
        >
          <div style={{ flex: 1 }}>
            <h3
              style={{
                color: '#2a081a',
                margin: '0 0 6px 0',
                fontSize: '12px',
                fontWeight: 'bold',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              PAYMENT DETAILS
            </h3>
            <div style={{ fontSize: '10px', lineHeight: '1.2' }}>
              <div>
                <strong>Method:</strong> {order.paymentMethod || 'N/A'}
              </div>
              {order.razorpayOrderId && (
                <div>
                  <strong>Transaction ID:</strong> {order.razorpayOrderId}
                </div>
              )}
              <div>
                <strong>Status:</strong> {order.payment ? 'Paid' : 'Pending'}
              </div>
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ textAlign: 'right' }}>
              <div
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f8f9fa',
                }}
              >
                {(() => {
                  // Calculate subtotal from items
                  const itemsTotal = order.items.reduce(
                    (sum, item) => sum + item.price * item.quantity,
                    0
                  );

                  // Calculate discount from coupon
                  let discount = 0;
                  let discountText = '';
                  if (order.couponCode) {
                    const couponUpper = order.couponCode.toUpperCase();
                    if (couponUpper.startsWith('EKA')) {
                      const couponValue = couponUpper.replace('EKA', '');
                      if (
                        couponValue.endsWith('%') ||
                        (!couponValue.includes('%') &&
                          parseInt(couponValue) <= 100 &&
                          parseInt(couponValue) > 0)
                      ) {
                        // Percentage discount
                        const percentage = parseInt(couponValue.replace('%', ''));
                        discount = (itemsTotal * percentage) / 100;
                        discountText = `${percentage}% off`;
                      } else {
                        // Fixed amount discount
                        discount = parseInt(couponValue) || 0;
                        discountText = `₹${discount} off`;
                      }
                    }
                  }

                  // Calculate delivery charge: Grand Total - (Subtotal - Discount)
                  const afterDiscount = itemsTotal - discount;
                  const deliveryCharge = order.amount - afterDiscount;

                  return (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: '4px',
                          fontSize: '10px',
                        }}
                      >
                        <span>Subtotal:</span>
                        <span>₹{itemsTotal.toFixed(2)}</span>
                      </div>

                      {order.couponCode && discount > 0 && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '4px',
                            fontSize: '10px',
                            color: '#22c55e',
                          }}
                        >
                          <span>
                            Coupon ({order.couponCode}) - {discountText}:
                          </span>
                          <span>-₹{discount.toFixed(2)}</span>
                        </div>
                      )}

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: '6px',
                          fontSize: '10px',
                          paddingBottom: '6px',
                          borderBottom: '1px solid #ddd',
                        }}
                      >
                        <span>Delivery Charge:</span>
                        <span>
                          {order.deliveryFee !== undefined && order.deliveryFee !== null
                            ? `₹${order.deliveryFee.toFixed(2)}`
                            : deliveryCharge > 0
                            ? `₹${deliveryCharge.toFixed(2)}`
                            : 'Free'}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          color: '#2a081a',
                        }}
                      >
                        <span>GRAND TOTAL:</span>
                        <span>₹{order.amount.toFixed(2)}</span>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            textAlign: 'center',
            paddingTop: '12px',
            borderTop: '1px solid #ddd',
            fontSize: '9px',
            color: '#666',
          }}
        >
          Thank you for shopping with zarviya.
        </div>
      </div>
    );
  };

  // Styles
  const thStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    backgroundColor: '#f2f2f2',
    textAlign: 'left',
  };

  const tdStyle = {
    padding: '10px',
    border: '1px solid #ddd',
  };

  const generateInvoicePDF = async () => {
    setShowInvoice(true);

    setTimeout(() => {
      const element = invoiceRef.current;
      const images = element?.querySelectorAll('img') || [];

      Promise.all(
        Array.from(images).map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((res) => {
                img.onload = res;
                img.onerror = res;
              })
        )
      ).then(() => {
        html2pdf()
          .set({
            margin: [10, 10, 10, 10],
            filename: `Invoice_${order.orderId}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
              scale: 2,
              useCORS: true, // ✅ ensures remote logo loads properly
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          })
          .from(element)
          .save()
          .then(() => {
            setShowInvoice(false);
          })
          .catch((err) => {
            console.error('PDF generation failed:', err);
            setShowInvoice(false);
          });
      });
    }, 100);
  };

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/order/details/${orderId}`);
        if (response.data.success) {
          setOrder(response.data.order);
        } else {
          toast.error('Order not found.');
          navigate('/');
        }
      } catch (error) {
        console.error('Error fetching order details:', error.response?.data || error.message);
        toast.error('Failed to load order details. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (orderId) fetchOrderDetails();
  }, [orderId, navigate, backendUrl]);

  const copyTrackingId = () => {
    if (order?.trackingId && trackingIdRef.current) {
      navigator.clipboard
        .writeText(order.trackingId)
        .then(() => {
          setCopied(true);
          toast.success('Tracking ID copied to clipboard!');
          setTimeout(() => setCopied(false), 3000);
        })
        .catch(() => {
          toast.error('Failed to copy tracking ID');
        });
    }
  };

  const navigateToTracking = () => {
    if (order?.trackingId) {
      const trackingUrl = `https://www.dtdc.in/tracking/tracking_results.asp?Ttype=awbno&strCnno=${order.trackingId}`;
      window.open(trackingUrl, '_blank');
    }
  };

  if (loading)
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <Spinner />
      </div>
    );

  if (!order) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <FaBoxOpen className="text-4xl text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600 text-lg font-medium">Order not found</p>
          <p className="text-gray-500 mt-2">
            The order you're looking for doesn't exist or has been removed.
          </p>
          <button
            onClick={() => navigate('/')}
            className="mt-6 px-5 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition flex items-center justify-center mx-auto"
          >
            <FaArrowLeft className="mr-2" /> Back to Home
          </button>
        </div>
      </div>
    );
  }

  const trackingStages = ['Order Placed', 'Packing', 'Shipped', 'Out for delivery', 'Delivered'];

  const icons = [FaShoppingBag, BiPackage, FaTruck, MdLocalShipping, FaCheckCircle];

  // Determine which status to show in the tracking bar
  const isCancelled =
    order.status === 'Cancelled' || order.status === 'Cancelled and Eligible for Refund';
  const statusIndex = !isCancelled ? trackingStages.indexOf(order.status) : -1;

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-4 pt-32 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back button */}

        {/* Order Header Card */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-4 mb-4">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Order Details</h2>
              <p className="text-gray-500 mt-1">
                Order ID: <span className="text-red-500 font-medium">{order.orderId}</span>
              </p>
            </div>
            <div className="mt-3 sm:mt-0">
              <p className="text-gray-500">
                Placed on:{' '}
                {new Date(order.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
              <p className={`font-medium ${order.payment ? 'text-green-600' : 'text-amber-600'}`}>
                {order.payment ? 'Paid' : 'Payment Pending'}
              </p>
            </div>
          </div>

          {/* Tracking ID Section */}
          {/* <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Tracking Information</h3>
            <div className="flex items-center">
              <span className="text-gray-600 mr-2">Tracking ID:</span>
              {order.trackingId ? (
                <div className="flex items-center">
                  <span 
                    ref={trackingIdRef}
                    className="text-blue-600 cursor-pointer hover:underline mr-2"
                    onClick={navigateToTracking}
                  >
                    {order.trackingId}
                  </span>
                  <button 
                    onClick={copyTrackingId}
                    className="text-gray-500 hover:text-gray-700 mr-2"
                    title="Copy tracking ID"
                  >
                    <FaCopy />
                  </button>
                  <button
                    onClick={navigateToTracking}
                    className="text-gray-500 hover:text-gray-700"
                    title="Open tracking page"
                  >
                    <FaExternalLinkAlt />
                  </button>
                  {copied && <span className="text-green-500 text-sm ml-2">Copied!</span>}
                </div>
              ) : (
                <span className="text-gray-500">Updates in 48hrs</span>
              )}
            </div>
          </div> */}
          <button
            onClick={() => generateInvoicePDF()}
            className="mt-2 px-4 py-2 bg-[#2a081a] text-white text-sm mb-4 rounded hover:bg-[#D1856C] transition"
          >
            Download Invoice
          </button>

          {/* Tracking Progress Bar or Cancelled Status */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Order Status</h3>

            {isCancelled ? (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center">
                <FaTimesCircle className="text-2xl text-red-500 mr-3" />
                <div>
                  <p className="text-red-600 font-medium">{order.status}</p>
                  <p className="text-gray-600 text-sm mt-1">
                    {order.status === 'Cancelled and Eligible for Refund'
                      ? 'Your order has been cancelled and is eligible for a refund.'
                      : 'Your order has been cancelled.'}
                  </p>
                </div>
              </div>
            ) : (
              <div className="relative">
                {/* Connect line */}
                <div className="absolute top-6 left-0 right-0 h-1 bg-gray-200">
                  <div
                    className="h-full bg-[#d1856c] transition-all duration-500"
                    style={{
                      width: `${
                        statusIndex >= 0 ? (statusIndex / (trackingStages.length - 1)) * 100 : 0
                      }%`,
                    }}
                  ></div>
                </div>

                {/* Status points */}
                {/* Status points */}
                <div className="w-full overflow-x-auto pb-4">
                  <div className="flex justify-between min-w-full relative gap-2 sm:gap-4 md:gap-6">
                    {trackingStages.map((stage, index) => {
                      const Icon = icons[index];
                      const isActive = index <= statusIndex;
                      return (
                        <div key={index} className="flex flex-col items-center z-10 min-w-0 flex-1">
                          <div
                            className={`w-8 h-8 flex items-center justify-center rounded-full shadow-md transition-all duration-300 ${
                              isActive
                                ? 'bg-[#2a081a] text-white'
                                : 'bg-white text-gray-400 border border-gray-200'
                            }`}
                          >
                            <Icon className="w-4 h-4" />
                          </div>
                          <p
                            className={`text-xs sm:text-sm mt-1 font-sm text-center truncate w-full ${
                              isActive ? 'text-[#d1856c]' : 'text-gray-400'
                            }`}
                          >
                            {stage}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Order Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left column - Order Items */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center mb-4">
                <MdReceipt className="text-2xl text-blue-500 mr-2" />
                <h3 className="text-lg font-semibold text-gray-800">Order Items</h3>
              </div>

              {order.items.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row items-start sm:items-center gap-4 py-4 border-b last:border-b-0"
                   onClick={() =>
    navigate(`/product/${item._id || item.productId}`)
  }
                >
                  <div className="w-24 h-24 flex-shrink-0 bg-gray-100 rounded-md overflow-hidden">
                    <img
                      src={item.image[0]}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-grow">
                    <h4 className="text-gray-800 font-medium">{item.name}</h4>
                    <p className="text-sm text-gray-500">
                      Product ID: <span className="text-gray-700">{item.productId || 'N/A'}</span>
                    </p>
                    <div className="flex flex-wrap gap-x-4 text-sm text-gray-600 mt-1">
                      {item.sizes && item.sizes.length > 0 && item.size && <p>Size: {item.size}</p>}
                      <p>Qty: {item.quantity}</p>
                      <p>Price: ₹{item.price.toFixed(2)}</p>
                    </div>
                  </div>
                  <div className="text-right mt-2 sm:mt-0">
                    <p className="text-gray-800 font-semibold">
                      ₹{(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                </div>
              ))}

              {/* Order summary */}
              <div className="border-t mt-4 pt-4">
                <div className="flex justify-between text-gray-600">
                  <span>Total Amount</span>
                  <span>₹{order.amount}</span>
                </div>
                <div className="flex justify-between text-gray-600 mt-2">
                  <span>Shipping</span>
                  <span>{order.deliveryOption}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right column - Payment & Delivery Info */}
          <div className="space-y-6">
            {/* Payment Status */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-3">
                <MdPayment className="text-2xl text-indigo-500" />
                <h3 className="text-lg font-semibold text-gray-800">Payment Information</h3>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <div
                  className={`w-3 h-3 rounded-full ${
                    order.payment ? 'bg-green-500' : 'bg-amber-500'
                  }`}
                ></div>
                <p
                  className={`text-sm font-medium ${
                    order.payment ? 'text-green-600' : 'text-amber-600'
                  }`}
                >
                  {order.payment ? 'Payment Successful' : 'Payment Pending'}
                </p>
              </div>
              <p className="text-gray-600 text-sm">
                Method: {order.paymentMethod || 'Not specified'}
              </p>
              {order.paymentId && (
                <p className="text-gray-600 text-sm mt-1">Transaction ID: {order.paymentId}</p>
              )}
            </div>

            {/* Delivery Address */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-3">
                <FaHome className="text-2xl text-orange-500" />
                <h3 className="text-lg font-semibold text-gray-800">Delivery Address</h3>
              </div>
              {order.address && (
                <div className="text-gray-600">
                  <p className="font-medium">
                    {order.address.firstName && order.address.lastName
                      ? `${order.address.firstName} ${order.address.lastName}`
                      : 'Customer'}
                  </p>

                  <p className="mt-1">{order.address.street}</p>
                  <p>
                    {order.address.city}, {order.address.state} {order.address.zipcode}
                  </p>
                  <p>{order.address.country}</p>
                  <div className="border-t mt-3 pt-2">
                    <p>{order.address.email}</p>
                    <p>{order.address.phone}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Support Button */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-3">Need Help?</h3>
              <button
                onClick={() => (window.location.href = 'mailto:contact@zarviya.com')}
                className="w-full py-3 text-white rounded-md transition"
                style={{ backgroundColor: '#2a081a' }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#D1856C')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#2a081a')}
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>

      {showInvoice && <InvoiceComponent />}
    </div>
  );
};

export default OrderDetails;
